import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { IconContact404 } from '../../icons/svg';

class Contact404 extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="not-found">
        <div className="icon">{this.props.iconEmpty ? this.props.iconEmpty : <IconContact404 />}</div>
        <div className="text">
          <FormattedMessage
            id={"not_found"}
            defaultMessage={"No results were found"}
          />
        </div>
        <div className="desc">
          <FormattedMessage
            id={"not_found_contact"}
            defaultMessage={"We found no results matching your keywords. Try again with another keyword for better results"}
          />
        </div>
      </div>
    )
  }
}

export default injectIntl(Contact404)